import classNames from 'classnames';

export const Container: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={classNames('container px-6 md:px-[60px]', className)}>{children}</div>
);
